import React from "react"
import PropTypes from "prop-types"
import { useLocation, useParams } from "react-router-dom"
import { routes } from "router"
import styles from "./HostedBookingPage.module.css"

// The guide's hosted booking page: the widget in a full-page frame. A paid booking has its own
// address here too (bookingMode), so refreshing or reopening it shows the booking, not the list.
const HostedBookingPage = ({ experienceMode, bookingMode }) => {
  const { uuid, id } = useParams()
  const { search } = useLocation()
  const appOrigin = window.location?.origin || ""

  let framePath = `/embedded/experience_listing/${uuid}`
  if (experienceMode) framePath = `/embedded/experience_detail/${uuid}/${id}`
  if (bookingMode) framePath = `${routes.widgetBooking({ uuid, id })}${search}`
  const iframeSrc = `${appOrigin}/#${framePath}`

  return (
    <div className={styles.overlay}>
      <div className={styles.modalContent}>
        <iframe
          src={iframeSrc}
          className={styles.iframe}
          title="Book Now"
          allow="payment *"
        />
      </div>
    </div>
  )
}

HostedBookingPage.propTypes = {
  experienceMode: PropTypes.bool,
  bookingMode: PropTypes.bool
}

HostedBookingPage.defaultProps = {
  experienceMode: false,
  bookingMode: false
}

export default HostedBookingPage
